export interface exampleInterface {
    key: string;
}

export enum exampleEnum {
    key = "example1",
}

export const exampleConst = {
    key: { value: "0", name: "VALID", color: "success" },
};

export const MaritalStatus = {
    SINGLE: { value: "1", name: "Single" },
    MARRIED: { value: "2", name: "Married" },
    DIVORCED: { value: "3", name: "Divorced" },
};

export const PlatformInfo = {
    All: {
        value: "",
        name: "All",
        order: 1,
        color: "",
        icon: "assets/svg/icons/image-placeholder.svg",
        checked: false,
        checkedColor: "isCheckbox-checked",
        uncheckedColor: "isCheckbox-Unchecked",
    },
    ANDROID: {
        value: "1",
        name: "Android",
        order: 2,
        color: "success",
        icon: "assets/svg/icons/android_ic.svg",
        checked: false,
        checkedColor: "isCheckbox-checked-android",
        uncheckedColor: "isCheckbox-Unchecked-android",
    },
    IOS: {
        value: "2",
        name: "IOS",
        order: 3,
        color: "info",
        icon: "assets/svg/icons/ios_ic.svg",
        checked: false,
        checkedColor: "isCheckbox-checked-ios",
        uncheckedColor: "isCheckbox-Unchecked-ios",
    },
    WEB: {
        value: "3",
        name: "Web",
        order: 4,
        color: "progress",
        icon: "assets/svg/icons/globe.svg",
        checked: false,
        checkedColor: "isCheckbox-checked-web",
        uncheckedColor: "isCheckbox-Unchecked-web ",
    },
    ADMIN: {
        value: "4",
        name: "Admin",
        order: 5,
        color: "danger",
        icon: "assets/svg/icons/admin_blank_ic.svg",
        checked: false,
        checkedColor: "isCheckbox-checked-admin",
        uncheckedColor: "isCheckbox-Unchecked-admin",
    },
    OTHER: {
        value: "5",
        name: "Other",
        order: 6,
        color: "purple",
        icon: "assets/svg/icons/admin_blank_ic.svg",
        checked: false,
        checkedColor: "isCheckbox-checked-admin",
        uncheckedColor: "isCheckbox-Unchecked-admin",
    },
};

export interface ErrorReporting {
    customerId?: number;
    applicationId?: number;
    errorDetail?: {
        [key: string]: any;
    };
    apiPoint?: string;
}

export interface ApiResponse<T> {
    success: boolean;
    message: string | null;
    data: T;
    errorDetail?: { [key: string]: any } | null;
}

export enum DocumentTypeOfSummary {
    EMI_REPAYMENT_SCHEDULE = "EMI_REPAYMENT_SCHEDULE",
    PAYMENT_RECEIPT = "PAYMENT_RECEIPT",
    NOC = "NOC",
}

export enum DownloadResponseType {
    URL = "1",
    BUFFER = "2",
}

export type DevicePlatform = "android" | "ios" | "web" | "all";
